{
  "expo": {
    "scheme": "hozana",
    "name": "Hozana",
    "slug": "frontend-5",
    "version": "1.89.0",
    "experiments": {
      "reactCompiler": true
    },
    "android": {
      "versionCode": 0
    },
    "ios": {
      "buildNumber": "1.89.0"
    }
  }
}
